import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const tatreportsPlugin = createPlugin({
  id: 'tatreports',
  routes: {
    root: rootRouteRef,
  },
});

export const TatreportsPage = tatreportsPlugin.provide(
  createRoutableExtension({
    name: 'TatreportsPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
